<svg
  [attr.width]="width"
  [attr.height]="height"
  [attr.viewBox]="'0 0 24 24'"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    [attr.fill]="fillColor"
    d="M11.129 15.643a1 1 0 0 1 1.337-.097l.077.066.174.16A4.997 4.997 0 0 0 16 17a1 1 0 0 1 0 2 6.996 6.996 0 0 1-4.595-1.72l-.245-.223-.07-.074a1 1 0 0 1 .039-1.34ZM2 5c2.217 0 4.294.862 5.842 2.325a1 1 0 0 1-1.374 1.453A6.498 6.498 0 0 0 2 7a1 1 0 0 1 0-2Z"
  />
  <path
    [attr.fill]="fillColor"
    d="M22.643 19.044a1 1 0 0 0 0-1.696l-5.113-3.196A1 1 0 0 0 16 15v6.392a1 1 0 0 0 1.53.848l5.113-3.196ZM2.32 18.994a8.5 8.5 0 0 0 7.526-5.224l1.539-3.693A5 5 0 0 1 16 7a1 1 0 1 0 0-2 7 7 0 0 0-6.462 4.308L8 13a6.5 6.5 0 0 1-6 4 1 1 0 1 0 0 2l.32-.006Z"
  />
  <path
    [attr.fill]="fillColor"
    d="M21.643 7.044a1 1 0 0 0 0-1.696L16.53 2.152A1 1 0 0 0 15 3v6.392a1 1 0 0 0 1.53.848l5.113-3.196Z"
  />
</svg>
